import { css, useTheme } from '@emotion/react';

const useStyle = () => {
  const theme = useTheme();

  const { background, primary, text } = theme.palette;

  const { spacing } = theme;

  const hero = css`
    --height: unset;
    --bg: ${background.default};
    --show-overlay: block;
    --images-grid-area: 1/1;
    position: relative;
    max-width: 1440px;
    margin: 0 auto;
    background-color: var(--bg);

    height: var(--height);

    display: grid;
    grid-template-columns: 1fr;

    @media (min-width: 700px) {
      grid-template-columns: 44% 56%;
      grid-template-rows: 1fr auto;
      --height: 608px;
      --bg: ${background.gray3};
      --show-overlay: none;
    }

    & > .images {
      grid-area: var(--images-grid-area);
      height: 100%;
      width: 100%;
      position: relative;

      & img {
        object-fit: cover;
        object-position: center bottom;
        width: 100%;
        height: 100%;
      }

      & .mobile {
        height: 500px;
      }

      & .desktop {
        display: none;
        max-height: var(--height);
      }

      @media (min-width: 700px) {
        --images-grid-area: 1/2/2/3;
        & .mobile {
          display: none;
        }

        & .desktop {
          display: block;
        }
      }
    }

    & > .content {
      --btn-display: none;
      --subtitleFontWeight: 400;
      --subtitleMaxWidth: 214px;
      --padding: 25px;

      z-index: 1;
      padding: var(--padding);
      grid-area: 1 / 1;

      & .ctaButton {
        display: var(--btn-display);
      }

      & p,
      & h1 {
      }

      & h1 {
        margin-bottom: 15px;
      }

      & p {
        font-size: clamp(
          1rem,
          calc(1rem + (60 - 35) * ((100vw - 320px) / (1440 - 320))),
          1.5rem
        );
        line-height: clamp(
          1.313rem,
          calc(1.313rem + (65 - 40) * ((100vw - 320px) / (1440 - 320))),
          1.875rem
        );
        font-weight: var(--subtitleFontWeight);
        max-width: var(--subtitleMaxWidth);
      }

      @media (min-width: 400px) {
        --subtitleMaxWidth: 100%;
      }

      @media (min-width: 700px) {
        display: block;
        --btn-display: flex;
        --padding: 25px 50px 25px;
        --header-spacing: unset;
        --subtitleFontWeight: 300;
      }

      @media (min-width: 900px) {
        --padding: 75px 25px 75px 50px;
      }
    }

    & > .actions {
      --color: ${primary.main};
      --btn-display: flex;
      --padding: 25px;
      --award-max-width: 310px;

      grid-area: 2/1;

      bottom: 0;
      left: 0;
      height: auto;
      padding: var(--padding);

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      & .ctaButton {
        display: var(--btn-display);
      }

      & span {
        max-width: var(--award-max-width);
        font-weight: 700;
        margin-top: 25px;
      }

      @media (min-width: 700px) {
        --btn-display: none;
        --padding: 0 0 25px 50px;
        position: absolute;
        grid-area: 1/1/2/2;
      }

      @media (min-width: 900px) {
        padding: 0 0 50px 50px;
      }

      @media (min-width: 1200px) {
        padding: 0 0 75px 50px;
      }
    }

    &.lifestyle-variant {
      & > .content {
        --color: ${primary.contrastText};
      }

      & .images {
        padding-bottom: calc(100% / calc(807 / 608));

        & .mobile {
          height: 100%;
          position: absolute;
          inset: 0;
        }
        & .desktop {
          object-position: right;
          width: 100%;
          object-fit: contain;
        }
      }

      @media (min-width: 700px) {
        & .images {
          padding-bottom: unset;
        }

        & > .content {
          --color: ${text.primary};
        }
      }
    }

    &.equipment-variant {
      --p-display: none;
      & > .content {
        & p {
          display: var(--p-display);
        }
      }

      @media (min-width: 700px) {
        --p-display: block;
      }
    }

    &.tan-variant {
      --images-grid-area: 2/1;

      & > .images {
        & .mobile {
          height: 100%;
          object-fit: contain;
          width: 100%;
        }
      }

      & > .content {
        grid-area: 1/1;
        background-color: ${background.gray3};
      }

      & > .actions {
        grid-area: 3/1;
        z-index: 1;
      }
    }
  `;

  const cta = css`
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
    max-width: 290px;
    align-items: center;

    & p {
      font-size: 14px !important;
      line-height: 14px !important;
      text-align: center;
      font-weight: 400 !important;
    }

    @media (min-width: 700px) {
      margin: 50px 0 0;
    }
  `;

  const headerHeading = css`
    margin-bottom: ${spacing(1)};

    @media (max-width: ${`${400}px`}) {
      font-size: 24px;
      line-height: 30px;
    }
  `;

  return {
    hero,
    cta,
    headerHeading,
  };
};

export default useStyle;
